import { httpRequest } from 'http'
import requestUnitRebuildInfo from './unit_rebuild_info'

import { sendErrorNotification } from 'helpers/web_to_client'

export const UNITS_REBUILD_REQUEST = 'units/REBUILD_REQUEST'
export const UNITS_REBUILD_SUCCESS = 'units/REBUILD_SUCCESS'
export const UNITS_REBUILD_ERROR = 'units/REBUILD_ERROR'

export function startRequest() {
    return {
        type: UNITS_REBUILD_REQUEST,
        payload: {},
    }
}

export function requestSuccess(resp) {
    const webToClient = []
    // notification has to be called before window will be closed
    if (typeof resp.message === 'string' && resp.message.length !== 0) {
        webToClient.push(
            {
                handler: 'sendNotification',
                params: {
                    type: 'Warning',
                    message: resp.message,
                },
            }
        )
    }
    webToClient.push(
        {
            handler: 'closeWindow',
            params: {
                windowId: 'browser',
            },
        },
    )

    return {
        type: UNITS_REBUILD_SUCCESS,
        payload: { },
        meta: { webToClient },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: UNITS_REBUILD_ERROR,
        payload: errorData,
    }
}

export default function(unitServerId, type, battleMode = null, direction = null) {
    return async (dispatch, getState) => {
        if (getState().unitRebuild.inProgress) {
            return
        }
        dispatch(startRequest())

        const data = { type }
        if (direction !== null) {
            data.direction = direction
        }
        if (battleMode !== null) {
            data.battle_mode = battleMode
        }

        httpRequest(`/game_api/units/${unitServerId}/rebuild`, 'PATCH', data)
            .then(
                resp => dispatch(requestSuccess(resp)),
                errorData => {
                    dispatch(requestError(errorData))
                    dispatch(requestUnitRebuildInfo())
                }
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/unit_rebuild.js